import React from 'react';
import { Link } from 'react-router-dom';
import useProduct from '../CustomHook/useProduct';
import InventoryItems from '../InventoryItems/InventoryItems';
import ManageItem from '../ManageItem/ManageItem';

const ManageInventory = () => {
    const [products, setProducts] = useProduct();
    const itemProducts = products;


    const handleDelete = (id) => {
        const url = `https://protected-plateau-21838.herokuapp.com/products/${id}`
        fetch(url, {
            method: 'DELETE'
        })
            .then(Response => Response.json())
            .then(data => {
                const remaining = products.filter(product => product._id !== id)
                setProducts(remaining)
            })
    }

    return (
        <div>

            <Link to='/additem'> <button className='btn btn-success mt-3'>Add New Item</button></Link>

            <h3 className='mt-4 mb-3'>All Inventory Items:{itemProducts.length}</h3>




            <div className="row container-fluid mt-2 ">
                {
                    itemProducts.map(product => <ManageItem handleDelete={handleDelete} key={product._id} product={product}></ManageItem>)

                }


            </div>
        </div>
    );
};

export default ManageInventory;